export default __webpack_public_path__ + "static/img-cnn-vault-21d343def95b81a2ad4872d7a8e1f1b6.png";